export const ROUTE = {
  // eslint-disable-next-line @stylistic/lines-around-comment
  LOGIN: "/admin/auth/login",
  LOGOUT: "/admin/auth/logout",
  FORGET_PASSWORD: "/admin/auth/forget-password",
  CHANGE_PASSWORD: "/admin/auth/change-password",
  RESET_PASSWORD: "/admin/auth/reset-password",
  INIT_PASSWORD: "/admin/auth/init-password",
  HOMEPAGE: "/admin",

  STORE_MANAGEMENT: "/admin/store-management",
  STORE_DEVICE: "/admin/store-management/devices",
  STORE_DETAIL: "/admin/store-management/detail",
  STORE_UPDATE: "/admin/store-management/update",
  STORE_SETTING: "/admin/setting",
  STORE_ADVERTISEMENT: "/admin/setting/advertisement",
  STORE_CATALOG: "/admin/setting/catalog",
  STORE_PRODUCT_DISPLAY: "/admin/setting/products",

  PRODUCT_MANAGEMENT: "/admin/product-management",
  PRODUCT_CREATE: "/admin/product-management/create",
  PRODUCT_DETAIL: "/admin/product-management/detail",
  PRODUCT_UPDATE: "/admin/product-management/update",

  TAG_MANAGEMENT: "/admin/tag-management",
  TAG_CREATE: "/admin/tag-management/create",
  TAG_DETAIL: "/admin/tag-management/detail",
  TAG_UPDATE: "/admin/tag-management/update",

  USER_MANAGEMENT: "/admin/user-management",
  USER_CREATE: "/admin/user-management/create",
  USER_DETAIL: "/admin/user-management/detail",
  USER_UPDATE: "/admin/user-management/update",

  NOT_FOUND: "/admin/errors/not-found",
  FORBIDDEN: "/admin/errors/forbidden",
  INTERNAL_SERVER_ERROR: "/admin/errors/internal-server-error",

  SIGNAGE_PRODUCTS_ALL: "/signage/products",
  SIGNAGE_PRODUCTS_TOP: "/signage/products/top",
  SIGNAGE_PRODUCTS_MAKER: "/signage/products/maker",
  SIGNAGE_PRODUCTS_EFFICACY: "/signage/products/efficacy",
  SIGNAGE_PRODUCT_DETAIL: "/signage/products/detail",
}
